// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__TvqPy","tab":"ProcedureTabs_tab__3PnA-"};